export default "__VITE_ASSET__B$vOaNEB__"